import moment from 'moment'
import store from '../../store'
import analytics from '../cdpAnalytics'

export function analyticsNowPlayingOpenDropdown(dropdown) {
  const state = store.getState()
  const { user } = state
  let userDaysOld
  if (user) {
    const { userCreated } = user
    const nowDate = moment()
    const seconds = Math.floor((nowDate - moment(userCreated)) / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    userDaysOld = Math.floor(hours / 24)
  }

  analytics.track('Open Now Playing Dropdown', {
    dropdown,
    userDaysOld,
  })
}
